import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_CLIENTS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const clients = {
  namespaced: true,
  state: buildInitialState({
    clientList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setClients: (state, clients) => {
      state.clientList = clients
    },
    setPaginatedClients (state, { result, totalRecords }) {
      state.clientList = result
      state.totalRecords = totalRecords
    }
  },
  actions: {
    getClients: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting clients, please wait...' })

      return api.doGet({ path: PATH_CLIENTS, parameters: filters })
        .then(json => json.data)
        .then(clients => {
          commit('updateStatus', { status: COMPLETE })
          commit('setClients', clients)
          return clients
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to select clients')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getClientOptions ({ dispatch }, filters = {}) {
      return api.doGet({ path: PATH_CLIENTS, parameters: filters })
        .then(json => json.data || [])
        .catch(() => {
          notifyError(dispatch, 'Unable to load clients')
          return []
        })
    },
    getFieldsWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getClients', { ...rootGetters['clientFilters/getSearchObject'] })
    },
    getClientsWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getClientsPaginated', {
        ...rootGetters['clientFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getClientsPaginated: createPaginatedGetAction(PATH_CLIENTS, 'setPaginatedClients', 'Unable to get clients')
  }
}

export default clients
